var exports = {
  "x": "xaf9ae18d--ee16a3--middle-navigation-btn",
  "Q": "xaf9ae18d--ee16a3--large-navigation-btn",
};

module.exports = exports;
